import ko from "knockout";
import manifestManager from "flow/utils/manifestManager";
import workingContext from "flow/viewModels/workingContext";
import config from "flow/config";
import * as _ from "underscore";
import MyFlow from "flow/MyFlow";

export interface IGroupMenuViewContext {
    isLibrary: boolean;
    functionType: string;
    title: string;
}

interface IGroup {
    moduleId: string;
    area: string;
    subMenuVisible: KnockoutObservable<boolean>;
    toggleSubMenuVisibility: () => void;
    groupItems: KnockoutObservableArray<IGroupItem>;
    sortOrderFlag: boolean;
}

interface IGroupItem {
    id: string;
    name: string;
    sortOrder: number;
    baseUrl: string;
    onSelect: (item: IGroupItem) => void;
}

function GroupMenu(myFlow: MyFlow) {
    const groups = ko.observableArray([]);
    const title = ko.observable();
    const isLibrary = ko.observable(false);
    const selectedComponentId = ko.observable();
    const moduleIds = ko.observableArray([]);

    myFlow.subscribe(config.topics.componentActivated, function () {
        const componentId = workingContext.currentFunctionComponentId();
        selectedComponentId(componentId);
    });

    const showModule = ko.pureComputed(function () {
        return groups().length > 1 || isLibrary() === true;
    });

    function activate(viewContext: IGroupMenuViewContext) {
        if (groups().length !== 0) {
            return;
        }

        const sortedGroups = [];

        isLibrary(viewContext.isLibrary);
        const functionType = viewContext.functionType;
        title(myFlow.translate(viewContext.title));
        const manifests = manifestManager.getGroupMenuManifests(functionType);
        //manifests = _.sortBy(manifests,
        //    function (item) {
        //        return item.groupMenuItem.sortOrder;
        //    });

        let i;

        for (i = 0; i < manifests.length; i++) {
            moduleIds.push(manifests[i].moduleId);
        }

        if (!moduleIds().every((val, _i, arr) => val === arr[0])) {
            for (i = 0; i < manifests.length; i++) {
                manifests[i].groupMenuItem.area = manifests[i].groupMenuItem.alternateAreaName
                    ? manifests[i].groupMenuItem.alternateAreaName
                    : manifests[i].groupMenuItem.area;
            }
        }

        for (i = 0; i < manifests.length; i++) {
            let inserted = false;
            const group: IGroup = {
                moduleId: manifests[i].moduleId,
                area: myFlow.translate(manifests[i].groupMenuItem.area),
                subMenuVisible: ko.observable(false),
                toggleSubMenuVisibility: function () {
                    this.subMenuVisible(!this.subMenuVisible());
                },
                groupItems: ko.observableArray([]),
                sortOrderFlag: false
            };
            const groupItem: IGroupItem = {
                id: manifests[i].id,
                name: myFlow.translate(manifests[i].groupMenuItem.name),
                sortOrder: manifests[i].groupMenuItem.sortOrder,
                baseUrl: manifests[i].baseUrl,
                onSelect: function (item) {
                    myFlow.activateById(item.id);
                    if (myFlow.isBreakpoint("xs")) {
                        myFlow.publish(config.topics.hideMenu);
                        myFlow.publish(config.topics.mobileMenuHide);
                    }
                }
            };

            if (sortedGroups.length > 0) {
                for (let j = 0; j < sortedGroups.length; j++) {
                    if (sortedGroups[j].area === myFlow.translate(manifests[i].groupMenuItem.area)) {
                        sortedGroups[j].groupItems.push(groupItem);
                        inserted = true;
                        if (manifests[i].groupMenuItem.sortOrder) {
                            sortedGroups[j].sortOrderFlag = true;
                        } else {
                            sortedGroups[j].sortOrderFlag = false;
                        }
                        break;
                    }
                }
                if (inserted === false) {
                    group.groupItems.push(groupItem);
                    sortedGroups.push(group);
                }
            } else {
                sortedGroups.push(group);
                sortedGroups[0].groupItems.push(groupItem);
            }
        }

        const language = myFlow.getCulture().split("-")[0];

        sortedGroups.sort(function (a, b) {
            return a.area.localeCompare(b.area, language);
        });

        for (i = 0; i < sortedGroups.length; i++) {
            if (!sortedGroups[i].sortOrderFlag) {
                sortedGroups[i].groupItems.sort(function (a, b) {
                    return a.name.localeCompare(b.name, language);
                });
            } else {
                sortedGroups[i].groupItems(
                    _.sortBy(sortedGroups[i].groupItems(), function (item) {
                        return item.sortOrder;
                    })
                );
            }
        }

        if (sortedGroups.length === 1) {
            sortedGroups[0].subMenuVisible(true);
        }

        groups(sortedGroups);
    }

    return {
        activate: activate,
        groups: groups,
        title: title,
        showModule: showModule,
        selectedComponentId: selectedComponentId
    };
}

export default GroupMenu;
